import { Refresh } from 'iconsax-reactjs';
import type { FC } from 'react';
import { Button, type ButtonProps } from '@/shared/Button';
import { type RevalidateTarget, useBackendRevalidate } from '..';

export const BackendRevalidateButton: FC<
  Omit<ButtonProps, 'children' | 'onClick' | 'fab' | 'aria-label'> & {
    keys: RevalidateTarget[];
  }
> = ({ keys, ...props }) => {
  const revalidate = useBackendRevalidate();

  return (
    <Button
      aria-label="Refresh"
      fab
      onClick={() => revalidate(keys)}
      {...props}
    >
      <Refresh size={props.size < 10 ? 14 : 16} />
    </Button>
  );
};
